'use client';
import React from 'react';

const TypeformWidget = ({ block, position }) => {
  const { external_link_url, _metadata } = block.typeform_widget;

  const { uid } = _metadata;

  // Process Typeform URL outside of render to prevent re-rendering
  const processedTypeformUrl = external_link_url
    ? (() => {
        const url = external_link_url.trim();
        let hostname;
        try {
          hostname = new URL(url).hostname;
        } catch {
          return null;
        }
        // Accept typeform.com and any subdomain of typeform.com
        if (
          hostname !== 'typeform.com' &&
          !hostname.endsWith('.typeform.com')
        ) {
          return null;
        }

        // Add embed parameters for full screen display
        try {
          const urlObj = new URL(url);
          urlObj.searchParams.set('embed-type', 'iframe');
          urlObj.searchParams.set('embed-opacity', '100');
          urlObj.searchParams.set('embed-background', 'transparent');
          urlObj.searchParams.set('embed-hide-headers', 'true');
          urlObj.searchParams.set('embed-hide-footer', 'true');
          urlObj.searchParams.set('embed-padding', '0');
          urlObj.searchParams.set('embed-spacing', 'compact');
          urlObj.searchParams.set('embed-layout', 'fullscreen');

          return urlObj.toString();
        } catch {
          // Invalid URL, do not render the iframe
          return null;
        }
      })()
    : null;

  return (
    <section
      id={`${uid}_${position}`}
      data-name="wayfinder-feature"
      className="w-full"
    >
      {processedTypeformUrl && (
        <div className="h-screen w-full">
          <iframe
            src={processedTypeformUrl}
            style={{
              width: '100%',
              height: '100%',
              maxHeight: '900px',
              border: 'none'
            }}
            title="Typeform"
            allow="camera; microphone; autoplay; encrypted-media; fullscreen"
            loading="lazy"
          >
            Loading…
          </iframe>
        </div>
      )}
    </section>
  );
};

export default TypeformWidget;
